import { Routes, Route } from 'react-router-dom'
import Tasks from './index/Tasks'
import TaskView from './show/TaskView'
import TaskForm from './form/TaskForm'
import Page404 from 'views/errors/Page404'
import { Role } from 'types'
import { useStateContext } from 'context/ContextProvider'

const TasksRoutes = () => {

  const { user } = useStateContext();

  if( ![Role.Admin,Role.Advisor,Role.Manager,Role.Accounting].some(value => user?.roles.includes(value))){
    return <Page404 />
  }

  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={<Tasks />}
        />
        <Route
          path="view/:id"
          element={<TaskView key="clientView" />}
        />
        <Route
          path="new"
          element={<TaskForm key="taskCreate" />}
        />
        <Route
          path=":id"
          element={<TaskForm key="taskUpdate" />}
        />
      </Route>
    </Routes>
  )
}

export default TasksRoutes
